// extracted by mini-css-extract-plugin
export default {"otpContainer":"otp-input_otpContainer__LXe0+","otpInputsWrapper":"otp-input_otpInputsWrapper__amhPg","otpInput":"otp-input_otpInput__LoWeH","error":"otp-input_error__zPyF3"};